import React, { useEffect, useState } from "react";
import { Checkbox, Button } from "@my-scoot/component-library-legacy";
import { walletKeys } from "features/Account/modules/Wallets/constants/Wallets.constants";
import { useWalletStore } from "features/Account/modules/Wallets/store/WalletStore";
import { useWallets } from "features/Account/modules/Wallets/utils/useWallets";
import { getAmountWithCurrenyString } from "features/Account/modules/Wallets/utils/Wallets.utils";
import { useInitiateDispute } from "../../../InitiateDisputeModal/useInitiateDispute";

export const DisputePaymentModalFooter = ({ record }) => {
  const { walletBalance, walletDeductionCalc, refreshWalletBalance } =
    useWallets({
      isFetchWalletBalanceEnabled: true,
    });
  const { handleDisputePayments } = useInitiateDispute();
  const disputeAmount = record?.dispute_amount;
  const isPayViaWallet = useWalletStore((state) => state.isPayViaWallet);
  const setIsPayViaWallet = useWalletStore((state) => state.setIsPayViaWallet);
  const isWalletActive = useWalletStore((state) => state.isWalletActive);
  const [isFullPaymentViaWallet, setIsFullPaymentViaWallet] = useState(false);
  const [payableAmout, setPayableAmount] = useState(disputeAmount);
  const buttonTextCondition = isPayViaWallet && isFullPaymentViaWallet;

  const handleWalletSelectionChange = (e) => {
    const isChecked = e?.target?.checked;
    setIsPayViaWallet(isChecked);
    if (isChecked) {
      const postDeductionList = walletDeductionCalc({
        totalAmount: disputeAmount,
      });
      setPayableAmount(postDeductionList?.totalAmount);
      if (postDeductionList?.totalAmount === 0) {
        setIsFullPaymentViaWallet(true);
      }
    } else {
      setPayableAmount(disputeAmount);
      setIsFullPaymentViaWallet(false);
    }
  };

  useEffect(() => {
    refreshWalletBalance();
  }, []);

  return (
    <>
      {isWalletActive && (
        <>
          <div className="tw-flex tw-items-center tw-justify-between tw-bg-[#F2F0FF] tw-leading-[14.32px] min-[768px]:tw-p-[10px] max-[767px]:tw-p-[10px_0px] tw-text-black tw-w-full tw-mt-[20px]">
            <span className="tw-text-[14px] tw-ml-[24px] tw-flex tw-items-center tw-gap-[10px]">
              <Checkbox
                size="large"
                wrapperClassName="!tw-border-[1.5px] !tw-border-solid !tw-border-[#493AB1]"
                disabled={
                  walletBalance?.[walletKeys.walletBalance] ? false : true
                }
                checked={isPayViaWallet}
                onChange={handleWalletSelectionChange}
              />
              <span className="tw-font-medium">
                Use Exly Wallet balance
                {"  "}
                <span className="!tw-font-normal tw-text-[#27252299]">
                  (Current balance:{" "}
                  {getAmountWithCurrenyString(
                    walletBalance?.[walletKeys.walletBalance]
                  )}
                  )
                </span>
              </span>
            </span>
          </div>
        </>
      )}
      <div className="tw-flex tw-justify-between tw-items-center tw-px-[24px] tw-py-[10px]">
        <div>
          <span>Amount to initiate dispute:</span>
          &nbsp;
          <strong>₹ {payableAmout}</strong>
        </div>
        <Button
          onClick={() => handleDisputePayments({ record: record })}
          color="primary"
        >
          {buttonTextCondition
            ? `Confirm Wallet Debit of ${getAmountWithCurrenyString(
                disputeAmount
              )}`
            : "Pay Now"}
        </Button>
      </div>
    </>
  );
};
